module.exports = {
      id: "illustrations:NZ01-usage",
      viewBox: "0 0 468.7 345.3",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:NZ01-usage",
      toString: function () {
        return this.url;
      }
    }